import {ActiveGoalButtonText} from './conditions/ActiveGoalButtonText'

export const conditionOptionsMap = {
    ACTIVE_GOAL: 'User has an active goal'
}

export const conditionComponentsMap = {
    [conditionOptionsMap.ACTIVE_GOAL]: ActiveGoalButtonText
}

export const editorStateMap = {
    CONDITION_MET: 'Condition Met',
    CONDITION_NOT_MET: 'Condition Not Met'
}
